export default () => {
  document.addEventListener('DOMContentLoaded', function () {
    const navSearchElement = document.querySelector('[data-controller="navigation-search-open"]');
    if (!navSearchElement) return;


    const button = navSearchElement.querySelector('[data-navigation-search-open-target="button"]');
    const drawDesktop = navSearchElement.querySelector('[data-navigation-search-open-target="drawDesktop"]');
    const drawMobile = navSearchElement.querySelector('[data-navigation-search-open-target="drawMobile"]');
    // Add close buttons as targets
    const closeDesktop = drawDesktop ? drawDesktop.querySelector('.navigation__search__draw__close-button') : null;
    const closeMobile = drawMobile ? drawMobile.querySelector('.navigation__search__draw__close-button') : null;
    if (!button) return;
    // Helper to close search drawer
    function closeSearchDrawer(isDesktop) {
      if (isDesktop && drawDesktop) {
        drawDesktop.classList.remove('open');
        setScrollLock(false);
        window.removeEventListener('keydown', handleKeydown);
      } else if (!isDesktop && drawMobile) {
        drawMobile.classList.remove('open');
        setScrollLock(false);
      }
    }

    // Scroll lock helper
    function setScrollLock(locked) {
      document.body.style.overflow = locked ? 'hidden' : '';
    }

    // Keydown handler for ESC
    function handleKeydown(e) {
      if (e.key === 'Escape' && drawDesktop && drawDesktop.classList.contains('open')) {
        drawDesktop.classList.remove('open');
        setScrollLock(false);
        window.removeEventListener('keydown', handleKeydown);
      }
    }

    button.addEventListener('click', function (e) {
      e.preventDefault();
      if (window.innerWidth >= 1024) {
        if (!drawDesktop) return;
        const isOpen = drawDesktop.classList.toggle('open');
        setScrollLock(isOpen);
        if (isOpen) {
          window.addEventListener('keydown', handleKeydown);
          const input = drawDesktop.querySelector('input[type="text"]');
          if (input) input.focus();
        } else {
          window.removeEventListener('keydown', handleKeydown);
        }
      } else {
        if (!drawMobile) return;
        const isOpen = drawMobile.classList.toggle('open');
        setScrollLock(isOpen);
        if (isOpen) {
          const input = drawMobile.querySelector('input[type="text"]');
          if (input) input.focus();
        }
      }
    });

    // Add click listeners to close buttons
    if (closeDesktop) {
      closeDesktop.addEventListener('click', function (e) {
        e.preventDefault();
        closeSearchDrawer(true);
      });
    }
    if (closeMobile) {
      closeMobile.addEventListener('click', function (e) {
        e.preventDefault();
        closeSearchDrawer(false);
      });
    }
  });
};